import React, { useState } from "react";
import ErrorWrapper from "../../wrapper/ErrorWrapper";
import { Provider } from "react-redux";
import { adminStore } from "../../../redux/store/adminStore";
import { Button } from "react-bootstrap";
import DownLoadModal from "./DownLoadModal";

const DownloadQrButton = ({ trans, qrDescription, qrLink, title, id }) => {
  const [isSHowModal, setIsShowModal] = useState(false);

  return (
    <Provider store={adminStore}>
      <ErrorWrapper>
        <Button
          className="download-qr-btn w-100 btn btn-success text-white rounded-1 py-xl-3 py-2 px-3 d-flex justify-content-between align-items-center"
          onClick={() => setIsShowModal(true)}
        >
          {trans["Download"]}
        </Button>
        {isSHowModal && (
          <DownLoadModal
            handleClose={() => setIsShowModal(false)}
            trans={trans}
            qrDescription={qrDescription}
            qrLink={qrLink}
            title={title}
            id={id}
          />
        )}
      </ErrorWrapper>
    </Provider>
  );
};

export default DownloadQrButton;
